import PropTypes from "prop-types";

import MenuItemPresenter from "presenters/MenuItemPresenter";
import { TermButton } from "pages/Search/components/styles";

const Term = ({ menuItem, onSearchTermClick }) => {
  return (
    <TermButton
      onClick={() => onSearchTermClick(MenuItemPresenter.linkTo(menuItem))}
      type="button"
      key={MenuItemPresenter.name(menuItem)}
    >
      {MenuItemPresenter.linkText(menuItem)}
    </TermButton>
  );
};

Term.propTypes = {
  menuItem: MenuItemPresenter.shape(),
  onSearchTermClick: PropTypes.func,
};

export default Term;
